export default __webpack_public_path__ + "static/media/IMG_2836.6c7c4d5b.JPG";